import React, { useState, useEffect } from "react";
import styles from "../css/styles.module.css";
import AddCustomer from "./addCustomer.js";
import EditCustomer from "./editCustomer.js";
import SearchBar from "./searchBar";
import { db } from "../config/firebase";
import trash from "../images/delete.png";

export default function Customer(props) {
  //setting up all the states
  const [data, setData] = useState(null);
  const [add, setAdd] = useState(false);
  const [remove, setRemove] = useState(false);
  const [edit, setEdit] = useState(false);
  const [chosenCustomer, setChosenCustomer] = useState(null);

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  //handling add button click which will display add form
  function handleAddClick() {
    setAdd(true);
  }

  //handling delete button click which will display the delete button on each row in the table
  function handleDeleteStartClick() {
    setRemove(!remove);
  }

  //handling trash icon click which will delete the data of that row from firestore
  function handleDeleteClick(key) {
    db.collection("customers").doc(key).delete();
  }

  //handle the edit button being click by displaying the edit form
  function handleEditClick(customer) {
    setChosenCustomer(customer);
    setEdit(true);
  }

  //handling adding new data to firestore
  function handleAddSubmit(newCustomer) {
    setAdd(false);
    db.collection("customers")
      .add(newCustomer)
      .catch((err) => {
        console.log(err);
      });
  }

  //handle edit form submit by updating the chosen customer's record
  function handleEditSubmit(e, customer) {
    e.preventDefault();
    setEdit(false);
    db.collection("customers")
      .doc(chosenCustomer.id)
      .set(customer)
      .catch((err) => {
        console.log(err);
      });
  }

  //handling user clicking cancel at the add form
  function handleCancelClick() {
    setAdd(false);
    setEdit(false);
  }

  //handling user changing input in search bar
  function handleSelectChange(selected) {
    //if selected input matches the customer value then only show match value
    if (selected) {
      setData(
        props.data.filter((d) => {
          return d.data.name === selected.value;
        })
      );
    } else {
      //else display all the data
      setData(props.data);
    }
  }

  ///if add button is clicked, show the add data form
  if (add) {
    return (
      <div className={styles.addContainer}>
        <AddCustomer
          handleAddSubmit={handleAddSubmit}
          handleCancelClick={handleCancelClick}
        />
      </div>
    );
  } else if (edit) {
    return (
      <div className={styles.addContainer}>
        <EditCustomer
          handleEditSubmit={handleEditSubmit}
          handleCancelClick={handleCancelClick}
          customer={chosenCustomer}
        />
      </div>
    );
  } else {
    //else show the data table
    return (
      <div className={styles.subContent}>
        <div className={styles.contentHeaderContainer}>
          <h1>Customers</h1>
          <SearchBar
            options={props.search}
            placeholder="Search by name..."
            errorMessage="No customer with that name"
            handleSelectChange={handleSelectChange}
            isClearable={true}
          />
          <div className={styles.buttonContainer}>
            <button onClick={handleAddClick} className={styles.addButton}>
              Add +
            </button>
            <button
              onClick={handleDeleteStartClick}
              className={styles.deleteButton}
            >
              {remove ? "Cancel" : "Delete -"}
            </button>
          </div>
        </div>
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <td>Name</td>
                <td>Address</td>
                <td>Phone Number</td>
                <td>Website</td>
                <td className={styles.small}></td>
                {remove && <td className={styles.small}></td>}
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((customer) => {
                  return (
                    <tr key={customer.id}>
                      <td>{customer.data.name}</td>
                      <td>{customer.data.address}</td>
                      <td>{customer.data.phone}</td>
                      <td>{customer.data.website}</td>
                      <td
                        className={styles.editButton}
                        onClick={() => handleEditClick(customer)}
                      >
                        Edit
                      </td>
                      {remove && (
                        <td
                          className={styles.trashButton}
                          onClick={() => handleDeleteClick(customer.id)}
                        >
                          <img src={trash} alt="Delete" />
                        </td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
